import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { APIGetTutorsMinors, APIGetAccountnfo, APIVerifyTutor } from "../apiRoutes"
import { BehaviorSubject } from 'rxjs';

export interface PayloadGetMinors {
  uid: string;
}
@Injectable({
  providedIn: 'root'
})
export class TutorService {

  minorsStatus = new BehaviorSubject({counter:0, emailList:[{email:"", pending:false, active:false}], email:""});
  minorsStatus$= this.minorsStatus.asObservable();

  changeStatus = new BehaviorSubject({active:false, pending:false, email:{}});
  changeStatus$= this.changeStatus.asObservable();

  tutorWithoutChilds = new BehaviorSubject(false);
  tutorWithoutChilds$ = this.tutorWithoutChilds.asObservable();


  constructor(public http: HttpClient) { }

  getMinor<responseGetAccountInfo>(uid: string | null) {
    return this.http.get<any>(`${environment.domainBackEnd}${APIGetAccountnfo}?uid=${encodeURIComponent(uid??"")}`, {
      headers: {
        "Content-Type": "application/json"
      }
    });
  }

  getListOfMinorsManaged<responseGetAccountInfo>(infoTutor: PayloadGetMinors | null) {
    return this.http.get<any>(`${environment.domainBackEnd}${APIGetTutorsMinors}?uid=${infoTutor?.uid}`, {
      headers: {
        "Content-Type": "application/json"
      }
    }
    );
  }
  verifyEmailTutor(uid:any){
    return this.http.put<any>(
      environment.domainBackEnd+APIVerifyTutor,
      {uid:uid});
  }

}
